import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomCheckoutService } from '@checkout/feature';
import { CustomOrder } from '@order/const';
import { CurrentProfile } from '@user/const';
import { CurrentProfileService } from '@user/feature';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'sd-order-confirmation-info-title',
  templateUrl: './order-confirmation-info-title.component.html',
  styleUrls: ['./order-confirmation-info-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorOrderConfirmationInfoTitleComponent implements OnInit {
  currentProfile$: Observable<CurrentProfile>;
  order$: Observable<CustomOrder>;

  constructor(
    private customCheckoutService: CustomCheckoutService,
    private currentProfileService: CurrentProfileService,
  ) {}

  ngOnInit(): void {
    this.currentProfile$ = this.currentProfileService.get();
    this.order$ = this.customCheckoutService
      .getOrderDetails()
      .pipe(filter<CustomOrder>((order) => Object.keys(order || {}).length > 0));
  }
}
